package com.pincer.core.model.tree

import kotlinx.serialization.Serializable
import kotlin.js.JsName

/*
A Participation is a summary of a Pincer from the perspective of a particular Participant.
They are indexed by pid.
*/

@Serializable
data class Participation

(

    @JsName("parent")    var parent    : String? = null,
    @JsName("name")      var name      : String? = null,
    @JsName("summary")   var summary   : String? = null,
    @JsName("roles")     var roles     : String? = null,
    @JsName("hash")      var hash      : Int? = null,
    @JsName("candidate") var candidate : Candidate? = null,

)

{

    fun duplicate() = Participation(parent = parent, name = name, summary = summary, roles = roles, hash = hash, candidate = candidate?.duplicate())

    fun includesRole(role: String): Boolean = ",$roles,".contains(",$role,")

}
